import { Component, OnInit, OnDestroy, EventEmitter, Output, Input } from '@angular/core';
import { FormControl } from '@angular/forms';
import {
  CurrencyService,
  CurrencyContainerModel,
  ApiVisa
} from 'blg-akaun-ts-lib';
import { ReplaySubject } from 'rxjs';
import { debounceTime, distinctUntilChanged } from 'rxjs/operators';
import { SubSink } from 'subsink2';
import { AppConfig } from '../../shared-utilities/visa';


@Component({
  selector: 'app-currency-v1',
  templateUrl: './currency.component.html',
  styleUrls: ['./currency.component.css']
})
export class SelectCurrencyDropDownComponent implements OnInit, OnDestroy {

  @Input() currency: FormControl;
  apiVisa = AppConfig.apiVisa;
  @Output() currencyChange = new EventEmitter<FormControl>();
  @Output() selectionChange = new EventEmitter();

  private subs = new SubSink();


  filterControl = new FormControl();
  filteredOptions$: ReplaySubject<CurrencyContainerModel[]> = new ReplaySubject<CurrencyContainerModel[]>(1);
  currencyList: CurrencyContainerModel[];

  constructor( 
    private currencyService: CurrencyService
  ) {}

  ngOnInit() {
    this.subs.sink = this.currencyService.get(this.apiVisa).subscribe(
      {next: resolve => {
        this.currencyList = resolve.data;
        this.filteredOptions$.next(this.currencyList);
        this.currency.patchValue('MYR');
      }});
    // if (this.currency.value) {
    //   this.subs.sink = this.currencyService.getByGuid(this.currency.value, this.apiVisa).subscribe( resolved => {
    //     this.branchList = [resolved.data];
    //     this.filteredOptions$.next([resolved.data]);
    //     this.onSelect(resolved.data.bl_fi_mst_branch.guid.toString());
    //   });
    // }
    this.subs.sink = this.filterControl.valueChanges.pipe(
      debounceTime(300),
      distinctUntilChanged()
    ).subscribe({next: resolve => this.filterCurrency(resolve)});
  }

  filterCurrency(search: string) {
    if (!search) {
      this.filteredOptions$.next(this.currencyList);
    } else {
      search = search.toLocaleLowerCase();
      const filter = this.currencyList.filter(c => c.bl_fi_mst_ccy.display_short.toLocaleLowerCase().includes(search));
      this.filteredOptions$.next(filter);
    }

  }

  ngOnDestroy() {
    this.subs.unsubscribe();
  }
}
